import { Component } from '@angular/core';
import { ActionNotification } from '../../../models/notification/action-notification.model'
import { ActionNotificationService } from '../../../services/notification/action-notification.service';
import { Customer } from '../../../models/customer/customer-model'
import { CustomerService } from '../../../services/customer/customer.service';

@Component({
  selector: 'app-create-action-notification',
  templateUrl: './create-action-notification.component.html',
  styleUrls: ['./create-action-notification.component.css']
})
/** create-action-notification component*/
export class CreateActionNotificationComponent {
  public notification = new ActionNotification();
  public customerList: Customer[];
  public htmlContent: any;
  /** create-action-notification ctor */
  constructor(private readonly actionNotificationService: ActionNotificationService, private readonly customerService: CustomerService) {
    this.notification.isActive = true;
    this.notification.customerID = 0;
    this.getVendors();
  }

  getVendors() {
    this.customerService.getVendorsList().subscribe(
      data => {
        this.customerList = data;
      }
    )
  }
  
  //onContentChange(html: string): void {
  //  this.notification.notificationDetail = html;
  //}

  onSubmit() {
    this.notification.notificationDetail = this.htmlContent;
    this.actionNotificationService.AddActionNotification(this.notification);
  }
}



// WEBPACK FOOTER //
// ./src/app/notification-components/action-based-notifications/create-action-notification/create-action-notification.component.ts